// // Components
// import TbhLogoWithText from '../common/TbhLogoWithText';

// //Stylesheet
// import '../App.css';
// import { ForgotPasswordForm } from '../features/forgotPassword/ForgotPasswordForm';
// import { useState } from 'react';
// import { RecoveryLinkSent } from '../features/forgotPassword/RecoveryLinkSent';

// const ForgotPasswordPage = () => {
//   const [recoveryLinkSent, setRecoveryLinkSent] = useState(false);
//   const [email, setEmail] = useState('');
//   return (
//     <div className='forgotPasswordContainer'>
//       <div className=''>
//         <div className='logoContainer'>
//           <TbhLogoWithText />
//         </div>
//         <div className=''>
//           <div className='formContainer'>
//             {!recoveryLinkSent ? (
//               <ForgotPasswordForm
//                 setRecoveryLinkSent={setRecoveryLinkSent}
//                 setUserEmail={setEmail}
//               />
//             ) : (
//               <RecoveryLinkSent email={email} />
//             )}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ForgotPasswordPage;
// Images
import { globalIcon } from '../assets/images/login';

// Components
import TbhLogoWithText from '../common/TbhLogoWithText';
import LoginForm from '../features/authentication/LoginForm';
import WeAreGlobal from '../features/authentication/WeAreGlobal';

//Stylesheet
import '../App.css';
import { ForgotPasswordForm } from '../features/forgotPassword/ForgotPasswordForm';
import AuthWrapper from '../components_/layout/AuthWrapper';

const ForgotPasswordPage = () => {
  return (
    <AuthWrapper>
      <ForgotPasswordForm />
    </AuthWrapper>
  );
};

export default ForgotPasswordPage;
